import type { PD } from "~/types/pd";

// Kept out of usePd so middleware and stores can use it without pulling in
// route-dependent composables like useBreadcrumbs.
export function useOnboardingCourses() {
   const $apiFetch = useNuxtApp().$apiFetch;
   const { logInfo, logError } = useDebugger();

   const onboardingCourses = useState<PD.OnboardingCoursesResponse | null>(
      "onboardingCourses",
      () => null,
   );

   const queryOnboardingCourses =
      async (): Promise<PD.OnboardingCoursesResponse> => {
         try {
            const data = await $apiFetch<PD.OnboardingCoursesResponse>(
               `pd/onboarding-courses`,
            );
            logInfo(`PD Onboarding Courses`, data);
            onboardingCourses.value = data;
            return data;
         } catch (err) {
            logError("queryOnboardingCourses failed", err);
            throw err;
         }
      };

   return { onboardingCourses, queryOnboardingCourses };
}
